export default {
  label: 'Sekce účtu',
  account: 'Účet',
  dashboard: 'Přehled',
  orders: 'Objednávky',
  wishlist: 'Oblíbené',
  billing: 'Platby a fakturace',
  settings: 'Nastavení',
};
